"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadConfig = loadConfig;
const ethers_1 = require("ethers");
function loadConfig(json) {
    const quotesParam = {};
    for (const symbol in json.quotesParam) {
        const item = json.quotesParam[symbol];
        quotesParam[symbol] = {
            tradingFeeRatio: item.tradingFeeRatio,
            stabilityFeeRatioParam: ethers_1.BigNumber.from(item.stabilityFeeRatioParam),
            protocolFeeRatio: item.protocolFeeRatio,
            qtype: Number(item.qtype),
            minMarginAmount: ethers_1.BigNumber.from(item.minMarginAmount),
            tip: ethers_1.BigNumber.from(item.tip),
        };
    }
    const config = {
        ...json,
        quotesParam,
    };
    return config;
}
